var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWalletIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 5.45825V3.45825C15 2.92782 14.7893 2.41911 14.4142 2.04404C14.0391 1.66897 13.5304 1.45825 13 1.45825H3C2.46957 1.45825 1.96086 1.66897 1.58579 2.04404C1.21071 2.41911 1 2.92782 1 3.45825V9.45825C1 9.98868 1.21071 10.4974 1.58579 10.8725C1.96086 11.2475 2.46957 11.4583 3 11.4583H5M7 15.4583H17C17.5304 15.4583 18.0391 15.2475 18.4142 14.8725C18.7893 14.4974 19 13.9887 19 13.4583V7.45825C19 6.92782 18.7893 6.41911 18.4142 6.04404C18.0391 5.66897 17.5304 5.45825 17 5.45825H7C6.46957 5.45825 5.96086 5.66897 5.58579 6.04404C5.21071 6.41911 5 6.92782 5 7.45825V13.4583C5 13.9887 5.21071 14.4974 5.58579 14.8725C5.96086 15.2475 6.46957 15.4583 7 15.4583ZM14 10.4583C14 10.9887 13.7893 11.4974 13.4142 11.8725C13.0391 12.2475 12.5304 12.4583 12 12.4583C11.4696 12.4583 10.9609 12.2475 10.5858 11.8725C10.2107 11.4974 10 10.9887 10 10.4583C10 9.92782 10.2107 9.41911 10.5858 9.04404C10.9609 8.66897 11.4696 8.45825 12 8.45825C12.5304 8.45825 13.0391 8.66897 13.4142 9.04404C13.7893 9.41911 14 9.92782 14 10.4583Z",
    stroke: "#6B7280",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/wallet-icon.5101cf0baa5443e3309b7bc87d7a4b18.svg";
export { ForwardRef as ReactComponent };